import React, { useState } from 'react';
import { Form, InputGroup, Button } from 'react-bootstrap';

const SmartSelect = ({
    label,
    name,
    value,
    onChange,
    options = [],
    displayField,
    loading = false,
    placeholder = "Seleccionar...",
    allowCustom = false,
    required = false,
    optional = false,
    disabled = false,
    mode = 'create'
}) => {
    const [isCustomMode, setIsCustomMode] = useState(false);

    const favoriteOptions = options.filter(opt => opt.isFavorite);
    const regularOptions = options.filter(opt => !opt.isFavorite);

    const handleCustomInput = (e) => {
        onChange(e);
    };

    const toggleCustomMode = () => {
        setIsCustomMode(!isCustomMode);
    };

    return (
        <Form.Group className="mb-3">
            <Form.Label className="d-flex align-items-center gap-2">
                {label}
                {required && <span className="text-danger">*</span>}
                {optional && <span className="badge bg-secondary small">Opcional</span>}
            </Form.Label>
            
            <InputGroup>
                {isCustomMode ? (
                    <Form.Control
                        type="text"
                        value={value}
                        onChange={handleCustomInput}
                        placeholder={`Escribir ${label.toLowerCase()}`}
                        disabled={disabled || loading}
                        required={required}
                    />
                ) : (
                    <Form.Select
                        value={value ?? '__PLACEHOLDER__'}
                        onChange={onChange}
                        name={name}
                        disabled={disabled || loading}
                        required={required}
                    >
                        {mode !== 'edit' && (
                            <option value="__PLACEHOLDER__">{loading ? 'Cargando...' : placeholder}</option>
                        )}
                        {favoriteOptions.map((option, index) => {
                            const displayValue = option[displayField] ?? option.name ?? '';
                            return (
                                <option
                                    key={`fav-${option.id || index}`}
                                    value={displayValue}
                                    style={{ fontWeight: 'bold' }}
                                >
                                    {displayValue}
                                </option>
                            );
                        })}
                        {regularOptions.map((option, index) => {
                            const displayValue = option[displayField] ?? option.name ?? '';
                            return (
                                <option
                                    key={`reg-${option.id || index}`}
                                    value={displayValue}
                                >
                                    {displayValue}
                                </option>
                            );
                        })}
                    </Form.Select>
                )}

                {allowCustom && mode !== 'edit' && (
                    <Button
                        variant="outline-secondary"
                        onClick={toggleCustomMode}
                        disabled={disabled || loading}
                        title={isCustomMode ? 'Usar lista' : 'Escribir texto libre'}
                    >
                        <i className={`bi bi-${isCustomMode ? 'list-ul' : 'pencil'}`}></i>
                    </Button>
                )}
            </InputGroup>

            {isCustomMode && (
                <Form.Text className="text-muted">
                    <i className="bi bi-info-circle me-1"></i>
                    Modo texto libre: escribe un valor personalizado
                </Form.Text>
            )}
            {disabled && !loading && (
                <Form.Text className="text-muted">
                    <i className="bi bi-info-circle me-1"></i>
                    Completa los campos anteriores para habilitar esta opción
                </Form.Text>
            )}
        </Form.Group>
    );
};

export default SmartSelect;